import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Home from "./pages/home";
import Solutions from "./pages/solutions";
import Industries from "./pages/industries";
import Developers from "./pages/developers";
import Compliance from "./pages/compliance";
import Company from "./pages/company";
import Contact from "./pages/contact";
import Cookie from "./pages/cookie";
import Privacy from "./pages/privacy";
import Terms from "./pages/terms";
import Complaints from "./pages/complaints";
import Fees from "./pages/fees";
import Disclosure from "./pages/disclosure";
import PrincipalAdverseImpacts from "./pages/principal-adverse-impacts/principal-adverse-impacts";
import BestExecution from "./pages/best-execution/best-execution";
import ConflictsOfInterest from "./pages/conflicts-of-interest/conflicts-of-interest";
import ScamPrevention from "./pages/scam-prevention/scam-prevention";
import Careers from "./pages/careers/careers";
import OpsManager from "./pages/careers/ops-manager";
import ProjectManager from "./pages/careers/project-manager";
import SolidityEngineer from "./pages/careers/solidity-engineer";
import FullstackEngineer from "./pages/careers/fullstack-engineer";
import QA from "./pages/careers/qa";
import JuniorLegalAnalyst from "./pages/careers/junior-legal-analyst";
import Four0Four from "./pages/404";

import "./App.scss";
import "./global.css";

const App = () => {
    return (
        <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/solutions" component={Solutions} />
            <Route exact path="/industries" component={Industries} />
            <Route exact path="/developers" component={Developers} />
            <Route exact path="/compliance" component={Compliance} />
            <Route exact path="/products-services" component={Company} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/cookie-policy" component={Cookie} />
            <Route exact path="/privacy-policy" component={Privacy} />
            <Route exact path="/terms-of-use" component={Terms} />
            <Route exact path="/complaints" component={Complaints} />
            <Route exact path="/fees" component={Fees} />
            <Route exact path="/important-disclosures-risks" component={Disclosure} />
            <Route exact path="/principal-adverse-impacts" component={PrincipalAdverseImpacts} />
            <Route exact path="/best-execution" component={BestExecution} />
            <Route exact path="/conflicts-of-interest" component={ConflictsOfInterest} />
            <Route exact path="/scam-prevention" component={ScamPrevention} />
            <Route exact path="/careers" component={Careers} />
            <Route exact path="/careers/junior-legal-analyst" component={JuniorLegalAnalyst} />
            <Route exact path="/careers/ops-manager" component={OpsManager} />
            <Route exact path="/careers/project-manager" component={ProjectManager} />
            <Route exact path="/careers/solidity-engineer" component={SolidityEngineer} />
            <Route exact path="/careers/fullstack-engineer" component={FullstackEngineer} />
            <Route exact path="/careers/qa" component={QA} />
            {/* Legacy redirects */}
            <Redirect exact from="/notices" to="/best-execution" />
            <Redirect from="/technology" to="/" />
            <Redirect from="/token" to="/" />
            <Redirect from="/company" to="/products-services" />
            <Redirect from="/about" to="/products-services" />
            <Redirect from="/enterprise-apis" to="/developers" />
            <Redirect from="/payments" to="/solutions" />
            <Route path="*" component={Four0Four} />
        </Switch>
    );
};

export default App;
